// extracted by mini-css-extract-plugin
export default {"music":"music_music__9bRfV"};